import { useParams } from 'react-router-dom';

import TermDetail from '@/component/terms/TermDetail';

export default function TermsDetailPage() {
  const { path = '', type = '' } = useParams();

  return <TermDetail path={path} type={type} />;
}
